import { useQuery } from '@tanstack/react-query';
import { parseDateToString } from '@utils/helpers';
import request from '@utils/request';
import { TablesAvailabilitySchema } from '../schemas/TablesAvailability.schema';
import { FIVE_MINUTES } from '@features/state/QueryClient/QueryClient';
export const TABLES_REQUEST_TIMEOUT = 15000;
export function useGetTablesAvailability(
  propertyId: number,
  date: string,
  restaurant: string,
  restaurantId: number | undefined,
  adults: number,
  children: number
) {
  return useQuery({
    queryKey: getTablesAvailabilityKey({
      propertyId,
      date,
      restaurant,
      restaurantId,
      adults,
      children,
    }),
    queryFn: () =>
      getTablesAvailability({ propertyId, date, restaurant, restaurantId, adults, children }),
    staleTime: FIVE_MINUTES,
    cacheTime: FIVE_MINUTES,
    enabled: !!restaurant && !!restaurantId,
  });
}

export async function getTablesAvailability({
  propertyId,
  date,
  restaurant,
  restaurantId,
  adults,
  children,
}: {
  propertyId: number;
  date: string;
  restaurant: string;
  restaurantId: number | undefined;
  adults: number;
  children: number;
}) {
  if (!restaurantId || !restaurant) return;

  const params = {
    'visit-date': parseDateToString(date),
    restaurant,
    'restaurant-id': restaurantId,
    adults,
    children: children ?? 0,
  };

  const response = await request.v2.get(`/${propertyId}/tables`, {
    params,
    timeout: TABLES_REQUEST_TIMEOUT,
  });
  const result = TablesAvailabilitySchema.safeParse(response.data);
  if (result.success) {
    return result.data;
  } else {
    return { promotions: [], timeSlots: [] };
  }
}

export const getTablesAvailabilityKey = ({
  propertyId,
  date,
  restaurant,
  restaurantId,
  adults,
  children,
}: {
  propertyId: number;
  date: string;
  restaurant: string;
  restaurantId: number | undefined;
  adults: number;
  children: number;
}) => ['tablesAvailability', propertyId, date, restaurant, restaurantId, adults, children];
